
<div class="changelog-dialog history-dialog">
    <mat-toolbar class="header heading-background">
        <div>
            <h5>Change History</h5>
        </div>
    </mat-toolbar>
    
        <!-- Filter Rows -->
        <div class="filter-row">
            <div class="filter-col">
                <mat-form-field appearance="outline" class="filter-form-field history-filter-field">
                    <mat-label>UTC Start Date</mat-label>
                    <input matInput [matDatepicker]="startPicker" [(ngModel)]="filterValues.startDate" (dateChange)="applyFilter()" placeholder="Start Date">
                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                    <mat-datepicker #startPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="filter-col">
                <mat-form-field appearance="outline" class="filter-form-field history-filter-field">
                    <mat-label>UTC End Date</mat-label>
                    <input matInput [matDatepicker]="endPicker" [(ngModel)]="filterValues.endDate" (dateChange)="applyFilter()" placeholder="End Date">
                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="filter-col">
                <mat-form-field appearance="outline" class="filter-form-field history-filter-field">
                    <mat-label>User</mat-label>
                    <input matInput [(ngModel)]="filterValues.user" (input)="applyFilter()" placeholder="User">
                </mat-form-field>
            </div>
        </div>
        <div class="filter-row">
            <div class="filter-col">
                <mat-form-field appearance="outline" class="filter-form-field history-filter-field">
                    <mat-label>Field</mat-label>
                    <input matInput [(ngModel)]="filterValues.field" (input)="applyFilter()" placeholder="Field">
                </mat-form-field>
            </div>
            <div class="filter-col">
                <mat-form-field appearance="outline" class="filter-form-field history-filter-field">
                    <mat-label>Old Value</mat-label>
                    <input matInput [(ngModel)]="filterValues.oldValue" (input)="applyFilter()" placeholder="Old Value">
                </mat-form-field>
            </div>
            <div class="filter-col">
                <mat-form-field appearance="outline" class="filter-form-field history-filter-field">
                    <mat-label>New Value</mat-label>
                    <input matInput [(ngModel)]="filterValues.newValue" (input)="applyFilter()" placeholder="New Value">
                </mat-form-field>
            </div>
        </div>
        <div #tableBody class="custom_small_panelbody_fix">
        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 mat-table-custom">
            <ng-container matColumnDef="UTCDate">
                <th mat-header-cell *matHeaderCellDef>UTC Date</th>
                <td mat-cell *matCellDef="let row">{{datePipe.transform(row.UTCDate,'yyyy-MM-dd HH:mm')}}</td>
            </ng-container>
            <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>User</th>
                <td mat-cell *matCellDef="let row">{{row.user}}</td>
            </ng-container>
            <ng-container matColumnDef="field">
                <th mat-header-cell *matHeaderCellDef>Field</th>
                <td mat-cell *matCellDef="let row">{{row.field}}</td>
            </ng-container>
            <ng-container matColumnDef="oldValue">
                <th mat-header-cell *matHeaderCellDef>Old Value</th>
                <td mat-cell *matCellDef="let row">{{row.oldValue}}</td>
            </ng-container>
            <ng-container matColumnDef="newValue">
                <th mat-header-cell *matHeaderCellDef>New Value</th>
                <td mat-cell *matCellDef="let row">{{row.newValue}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
        </table>
    </div>
    <br />
    <!-- <div class="changelog-dialog history-dialog"> -->
        <div class="button-container">
            <button mat-raised-button class="btn button-fix button-color-fix-red" (click)="close()">
                <mat-icon class="icon-color-fix">arrow_back_ios</mat-icon>
                Back
            </button>
        </div>
    </div>
<!-- </div> -->